var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _radialGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnonymous(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -68 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 79.53070084,
    x2: 79.53070084,
    xlinkHref: "#lg1",
    y1: 261.5567727448,
    y2: 269.533535388
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 808.49147 -67.637684)",
    gradientUnits: "userSpaceOnUse",
    x1: 374.5533,
    x2: 374.5533,
    xlinkHref: "#lg1",
    y1: 327.9084,
    y2: 335.854
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg1",
    y1: 279.3174580234,
    y2: 286.9896307318
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg1",
    y1: 251.3619448348,
    y2: 260.5452209376
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 145.0935337174,
    x2: 173.9227602226,
    xlinkHref: "#lg1",
    y1: 240.4491119104,
    y2: 350.5241396004
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b53759",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb5b0"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 155.2984008474,
    x2: 201.1629789862,
    xlinkHref: "#lg2",
    y1: 289.4741368974,
    y2: 398.2387452008
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 319.017964 -67.637684)",
    gradientUnits: "userSpaceOnUse",
    x1: -47.7014,
    x2: -18.9849,
    xlinkHref: "#lg1",
    y1: 306.8832,
    y2: 416.5282
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 340.8113401678,
    x2: 403.7113703324,
    xlinkHref: "#lg2",
    y1: 279.8544559012,
    y2: 397.7918995186
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 201.7469604136,
    x2: 176.6489104136,
    y1: 360.9784813474,
    y2: 260.5862813474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2137,
    stopColor: "#fec33a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#fbb740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    stopColor: "#f5a24b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8748,
    stopColor: "#ee865a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 245.8882060472,
    x2: 271.9901780472,
    xlinkHref: "#lg3",
    y1: 131.0522335314,
    y2: 300.7149511392
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 258.1482019034,
    x2: 252.7939847008,
    xlinkHref: "#lg3",
    y1: 151.1347896116,
    y2: 264.9126832064
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 321.0701175676,
    x2: 241.425672365,
    y1: 278.3787909534,
    y2: -13.4278034518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientUnits: "userSpaceOnUse",
    x1: 209.819698,
    x2: 343.175174909,
    y1: 105.6562194818,
    y2: 105.6562194818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 231.3059378206,
    x2: 287.6230506468,
    y1: 110.9220915484,
    y2: 244.917869909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#02e3b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#08d7ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#12c2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    stopColor: "#21a698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8029,
    stopColor: "#338189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9635,
    stopColor: "#495577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    cx: 253.6667,
    cy: 81.6864,
    gradientTransform: "matrix(1.003922 0 0 .608176 0 -35.312815)",
    gradientUnits: "userSpaceOnUse",
    r: 71.7149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b53759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3639,
    stopColor: "#cd525e",
    stopOpacity: 0.635294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7545,
    stopColor: "#e26962",
    stopOpacity: 0.247059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m97.875 291.984375h-24.816406c-6.558594 0-11.875-5.316406-11.875-11.875v-8.570313c0-6.558593 5.316406-11.878906 11.875-11.878906h24.816406zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m414.125 291.984375h24.816406c6.558594 0 11.875-5.316406 11.875-11.875v-8.570313c0-6.558593-5.316406-11.878906-11.875-11.878906h-24.816406zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m300.117188 277.496094-31.140626.066406s-57.09375.121094-57.09375.121094v30.898437h33.453126c.707031-3.136719 1.125-6.269531 1.265624-9.378906.230469-5.019531 4.371094-8.964844 9.398438-8.964844s9.167969 3.945313 9.398438 8.964844c.140624 3.109375.558593 6.242187 1.265624 9.378906h33.453126zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m214.722656 252.671875h82.554688v12.667969h-82.554688zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m164.703125 376.726562h-10.894531c-44.074219 0-79.808594-35.730468-79.808594-79.808593 0-29.742188 24.113281-53.855469 53.855469-53.855469h64.910156c38.335937 0 64.394531 38.914062 49.800781 74.359375l-4.070312 9.882813c-12.3125 29.902343-41.457032 49.421874-73.792969 49.421874zm0 0",
    fill: "url(#linear4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m163.929688 364.929688h-8.96875c-36.296876 0-65.722657-29.425782-65.722657-65.722657 0-24.496093 19.855469-44.351562 44.351563-44.351562h53.453125c31.570312 0 53.03125 32.046875 41.011719 61.238281l-3.351563 8.136719c-10.140625 24.628906-34.140625 40.699219-60.773437 40.699219zm0 0",
    fill: "url(#linear5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m347.296875 376.726562h10.894531c44.074219 0 79.808594-35.730468 79.808594-79.808593 0-29.742188-24.113281-53.855469-53.855469-53.855469h-64.910156c-38.335937 0-64.394531 38.914062-49.800781 74.359375l4.070312 9.882813c12.3125 29.902343 41.457032 49.421874 73.792969 49.421874zm0 0",
    fill: "url(#linear6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m348.070312 364.929688h8.96875c36.296876 0 65.722657-29.425782 65.722657-65.722657 0-24.496093-19.855469-44.351562-44.351563-44.351562h-53.453125c-31.570312 0-53.03125 32.046875-41.011719 61.238281l3.351563 8.136719c10.140625 24.628906 34.140625 40.699219 60.773437 40.699219zm0 0",
    fill: "url(#linear7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m242.566406 317.421875-4.066406 9.878906c-4.40625 10.703125-10.960938 20.070313-19.054688 27.699219l-109.015624-109.027344-.027344-.019531c5.46875-1.878906 11.34375-2.890625 17.457031-2.890625h64.902344c38.339843 0 64.402343 38.910156 49.804687 74.359375zm0 0",
    fill: "url(#linear8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m512 196.777344c0-33.078125-114.613281-59.894532-256-59.894532s-256 26.816407-256 59.894532c0 33.082031 114.613281 59.898437 256 59.898437s256-26.816406 256-59.898437zm0 0",
    fill: "url(#linear9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m256 247.304688c-134.644531 0-245.007812-24.320313-255.226562-55.210938-.507813 1.546875-.773438 3.109375-.773438 4.683594 0 33.082031 114.613281 59.898437 256 59.898437s256-26.816406 256-59.898437c0-1.574219-.265625-3.136719-.773438-4.683594-10.21875 30.890625-120.582031 55.210938-255.226562 55.210938zm0 0",
    fill: "url(#linear10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m512 196.777344c0-33.078125-114.613281-59.894532-256-59.894532-65.855469 0-125.898438 5.820313-171.261719 15.378907-4.167969 10.414062-6.703125 16.933593-6.703125 17.410156 0 3.875 2.273438 7.628906 6.503906 11.1875l71.03125 71.03125c30.835938 3.078125 64.78125 4.785156 100.429688 4.785156 141.386719 0 256-26.816406 256-59.898437zm0 0",
    fill: "url(#linear11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m296.234375 10.5c-23.976563 17.484375-56.492187 17.484375-80.46875 0-28.597656-20.851562-69.167969-9.402344-82.640625 23.328125-23.820312 57.878906-55.089844 134.167969-55.089844 135.847656 0 22.996094 79.679688 41.636719 177.964844 41.636719 98.289062 0 177.964844-18.640625 177.964844-41.636719 0-1.679687-31.265625-77.96875-55.089844-135.847656-13.46875-32.730469-54.042969-44.179687-82.640625-23.328125zm0 0",
    fill: "url(#linear12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m256 163.792969c-74.992188 0-139.144531-10.851563-165.34375-26.214844-7.578125 18.714844-12.621094 31.421875-12.621094 32.09375 0 23 79.679688 41.640625 177.964844 41.640625s177.964844-18.644531 177.964844-41.640625c0-.671875-5.042969-13.378906-12.621094-32.09375-26.199219 15.363281-90.351562 26.214844-165.34375 26.214844zm0 0",
    fill: "url(#linear13)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m339.324219 12.25c0-3.863281-.40625-7.648438-1.148438-11.335938-14.050781-2.570312-29.1875.289063-41.941406 9.589844-23.976563 17.480469-56.492187 17.480469-80.46875 0-12.753906-9.300781-27.890625-12.160156-41.941406-9.589844-.742188 3.6875-1.148438 7.472657-1.148438 11.335938 0 37.929688 37.304688 68.679688 83.324219 68.679688s83.324219-30.75 83.324219-68.679688zm0 0",
    fill: "url(#radial0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnonymous);
export default __webpack_public_path__ + "static/media/icon-anonymous.6d689df611b964d81215c702723f0bf7.svg";
export { ForwardRef as ReactComponent };